import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FitnessCenter } from '@mui/icons-material';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

function ExerciseRequestApprovedNotification({ notification }) {
  const { t } = useTranslation(['notifications']);
  const {
    data: {
      exercise_request: { name }
    }
  } = notification;

  return (
    <NotificationRowContent
      notification={notification}
      icon={FitnessCenter}
      title={t('exercise.approved.title', { ns: 'notifications' })}
      body={t('exercise.approved.body', { name, ns: 'notifications' })}
    />
  );
}

ExerciseRequestApprovedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      exercise_request: PropTypes.shape({
        created_exercise_id: PropTypes.number,
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default ExerciseRequestApprovedNotification;
